import { z } from 'zod';
const ATTENDANCE_EVENT_DETAIL_VIEWS = ['list', 'feed'] as const;
export type AttendanceEventDetailView = (typeof ATTENDANCE_EVENT_DETAIL_VIEWS)[number];

/**
 * 対象の絞り込み種別。未指定（`undefined`）は「全員」を表す。
 * `employee` は個人（1 名）、`organization` / `place` は複数名のスコープ。
 */
const ATTENDANCE_EVENT_TARGET_FILTER_TYPES = ['employee', 'organization', 'place'] as const;
export type AttendanceEventTargetFilterType = (typeof ATTENDANCE_EVENT_TARGET_FILTER_TYPES)[number];
export const SearchSchema = z.object({
  /** 選択中のステップ。未指定ならすべての Step を表示する。 */
  stepId: z.string().optional(),
  /**
   * 詳細を開いているタスク。Feed 表示では未指定なら先頭タスクを表示し、
   * List 表示では未指定のとき Step カード一覧を表示する。
   */
  taskId: z.string().optional(),
  /** 対象の絞り込み ID（Employee/Organization/Place のいずれかの識別子） */
  targetFilterId: z.string().optional(),
  /** 対象の絞り込み種別。`targetFilterId` とセットで指定する。 */
  targetFilterType: z.enum(ATTENDANCE_EVENT_TARGET_FILTER_TYPES).optional(),
  view: z.enum(ATTENDANCE_EVENT_DETAIL_VIEWS).default('list')
});